module.exports = __webpack_public_path__ + "img/icon-512x512.47fa01dc.png";